import React, { useEffect, useState } from 'react';
import {
    Box,
    Button,
    Center,
    CircularProgress,
    Flex,
    Grid,
    SimpleGrid,
    Text,
} from "@chakra-ui/react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { IoIosPeople } from "react-icons/io";
import { MdPages } from "react-icons/md";
import { FaSchool } from "react-icons/fa";
import { RiParentFill } from "react-icons/ri";
import { GiDoctorFace } from "react-icons/gi";
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';
import UpCommingReviews from "../../components/UpCommingReviews";
import { useNavigate } from "react-router-dom";
import { StudentScore } from "./StudentScore";
import ModernLoader from "../../components/ModernLoader";


const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#E91E63', '#9C27B0', '#F8BBD0', '#80DEEA'];

const RADIAN = Math.PI / 180;
const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    return (
        <text x={x} y={y} fill="white" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central" style={{ textShadow: '0 1px 2px rgba(0,0,0,0.4)', fontWeight: 600 }}>
            {`${(percent * 100).toFixed(0)}%`}
        </text>
    );
};


export default function HomePage() {

    const [dashboardData, setDashBoardData] = useState();
    const [loading, setLoading] = useState(true);
    const [pieChartDataByGender, setPieChartDataByGender] = useState([])
    const [pieChartDataTeacherByGender, setPieChartDataTeacherByGender] = useState([])
    const [pieChartDataTherapistByGender, setPieChartDataTherapistByGender] = useState([])
    const [countByDisabilityType, setCountByDisabilityType] = useState([])
    const [countByDisabilityId, setCountByDisabilityId] = useState([])

    useEffect(() => {
        onGetDashBoardData();
    }, [])

    const onGetDashBoardData = () => {
        axios.post('/dashboard', {
        }).then((res) => {
            let dataGender = [];

            dataGender.push({
                "name": "Male", "value": res.data.studentData.totalBoys ?? 0
            });
            dataGender.push({
                "name": "Female", "value": res.data.studentData.totalGirls ?? 0
            });
            dataGender.push({
                "name": "Others", "value": res.data.studentData.totalOthersGender ?? 0
            });
            setPieChartDataByGender(dataGender);
            let dataTeacherGender = [];
            dataTeacherGender.push({
                "name": "Male", "value": res.data.teacherData.totalMaleTeacher ?? 0
            });
            dataTeacherGender.push({
                "name": "Female", "value": res.data.teacherData.totalFemaleTeacher ?? 0
            });
            dataTeacherGender.push({
                "name": "Others", "value": res.data.teacherData.totalOthersTeacher ?? 0
            });
            setPieChartDataTeacherByGender(dataTeacherGender);
            let dataTherapistGender = [];
            dataTherapistGender.push({
                "name": "Male", "value": res.data.teacherData.totalMaleTherapist ?? 0
            });
            dataTherapistGender.push({
                "name": "Female", "value": res.data.teacherData.totalFemaleTherapist ?? 0
            });
            dataTherapistGender.push({
                "name": "Others", "value": res.data.teacherData.totalOthersTherapist ?? 0
            });
            setPieChartDataTherapistByGender(dataTherapistGender);

            if (res.data.countByDisabilityType) {
                let disData = [];
                disData.push({
                    "name": "Speech Related", "value": res.data.countByDisabilityType['Speech Related'] ?? 0
                });
                disData.push({
                    "name": "Visual Disability", "value": res.data.countByDisabilityType['Visual Disability'] ?? 0
                });
                disData.push({
                    "name": "Disability", "value": res.data.countByDisabilityType['Disability'] ?? 0
                });
                disData.push({
                    "name": "Autism", "value": res.data.countByDisabilityType['Autism'] ?? 0
                });
                disData.push({
                    "name": "Physicy Disability", "value": res.data.countByDisabilityType['Physicy Disability'] ?? 0
                });
                disData.push({
                    "name": "Multiple Disabilities", "value": res.data.countByDisabilityType['Multiple Disabilities'] ?? 0
                });
                disData.push({
                    "name": "Intellectual Disability",
                    "value": res.data.countByDisabilityType['Intellectual Disability'] ?? 0
                });
                disData.push({
                    "name": "Hearing Disability", "value": res.data.countByDisabilityType['Hearing Disability'] ?? 0
                }); disData.push({
                    "name": "Deafblindness", "value": res.data.countByDisabilityType['Deafblindness'] ?? 0
                });
                setCountByDisabilityType(disData);
            }
            if (res.data.countByDisabilityId) {
                let disData = [];
                disData.push({
                    "name": "Profound Disability (Red Color ID)", "value": res.data.countByDisabilityId['Profound Disability (Red Color ID)'] ?? 0
                }); disData.push({
                    "name": "Moderate Disability (Yellow Color ID)", "value": res.data.countByDisabilityId['Moderate Disability (Yellow Color ID)'] ?? 0
                }); disData.push({
                    "name": "Mild Disability (White Color ID)", "value": res.data.countByDisabilityId['Mild Disability (White Color ID)'] ?? 0
                }); disData.push({
                    "name": "Severe Disability (Blue Color ID)", "value": res.data.countByDisabilityId['Severe Disability (Blue Color ID)']
                });
                setCountByDisabilityId(disData);
            }


            setDashBoardData(res.data);
            setLoading(false);
        });
    }
    const { t } = useTranslation();
    const navigate = useNavigate();

    const statCards = [
        { label: t('studentLocal:students'), value: dashboardData?.studentData?.totalStudents ?? 0, icon: IoIosPeople, color: '#2563EB', path: '/my_students' },
        { label: t('common:plans'), value: dashboardData?.teacherData?.totalPlans ?? 0, icon: MdPages, color: '#059669', path: null },
        { label: t('school:title'), value: dashboardData?.studentData?.totalSchool ?? 0, icon: FaSchool, color: '#D97706', path: '/school' },
        { label: t('users:PARENT'), value: dashboardData?.teacherData?.totalParent ?? 0, icon: RiParentFill, color: '#7C3AED', path: '/user?role=PARENT' },
        { label: t('users:THERAPIST'), value: dashboardData?.teacherData?.totalTherapist ?? 0, icon: GiDoctorFace, color: '#DB2777', path: '/user?role=THERAPIST' },
    ];

    if (loading) {
        return <ModernLoader h="60vh" message="Gathering dashboard metrics..." />;
    }

    return (
        <Box fontFamily="heading">
            <Flex justifyContent="space-between" alignItems="center" mb={6}>
                <Text fontSize={{ base: 'xl', md: '2xl' }} fontWeight={700} color="gray.800">
                    Dashboard
                </Text>
                <Button
                    size="sm"
                    colorScheme="blue"
                    variant="ghost"
                    isLoading={loading}
                    onClick={() => {
                        setLoading(true);
                        axios.post('/dashboard/refresh').then(() => onGetDashBoardData());
                    }}
                >
                    Refresh Data
                </Button>
            </Flex>

            <SimpleGrid columns={{ base: 1, sm: 2, lg: 3, xl: 5 }} spacing={4} mb={8}>
                {statCards.map(({ label, value, icon: Icon, color, path }) => (
                    <Box
                        key={label}
                        bg="white"
                        borderRadius="xl"
                        p={5}
                        boxShadow="0 1px 3px rgba(0,0,0,0.08)"
                        borderLeft="4px solid"
                        borderLeftColor={color}
                        cursor={path ? 'pointer' : 'default'}
                        onClick={path ? () => navigate(path) : undefined}
                        _hover={path ? { boxShadow: '0 4px 12px rgba(0,0,0,0.12)', transform: 'translateY(-2px)', transition: 'all 0.2s' } : {}}
                        transition="all 0.2s"
                    >
                        <Flex alignItems="center" gap={3} mb={2}>
                            <Box color={color}><Icon size={24} /></Box>
                            <Text fontSize="sm" fontWeight={600} color="gray.600" noOfLines={1}>{label}</Text>
                        </Flex>
                        <Text fontSize={{ base: '2xl', md: '3xl' }} fontWeight={700} color="gray.800">{value}</Text>
                    </Box>
                ))}
            </SimpleGrid>
            <Grid templateColumns={{ base: '1fr', lg: dashboardData.upcomingReviews ? '1fr 1fr' : '1fr' }} gap={6} mb={6}>
                {dashboardData.upcomingReviews && (
                    <Box bg="white" borderRadius="xl" p={5} boxShadow="0 1px 3px rgba(0,0,0,0.08)" overflowX="auto">
                        <UpCommingReviews upcommingreviews={dashboardData.upcomingReviews} />
                    </Box>
                )}
                <Box bg="white" borderRadius="xl" p={5} boxShadow="0 1px 3px rgba(0,0,0,0.08)" textAlign="center">
                    <Text fontSize="lg" fontWeight={700} color="gray.800" mb={4}>Number of Students by Gender</Text>
                    <Box mx="auto" width="100%" h="320px">
                        <ResponsiveContainer width="100%" height="100%">
                            <PieChart>
                                <Pie
                                    data={pieChartDataByGender.filter(entry => entry.value !== 0)}
                                    labelLine={false}
                                    label={renderCustomizedLabel}
                                    outerRadius="80%"
                                    fill="#8884d8"
                                    dataKey="value"
                                >
                                    {pieChartDataByGender.map((entry, index) => (
                                        <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                    ))}
                                </Pie>
                            </PieChart>
                        </ResponsiveContainer>
                    </Box>
                    <Flex flexWrap="wrap" justify="center" gap={3} mt={2}>
                        {pieChartDataByGender.map((i, index) => (
                            <Flex key={i.name} alignItems="center" gap={2}>
                                <Box bg={COLORS[index % COLORS.length]} w="12px" h="12px" borderRadius="sm" />
                                <Text fontSize="sm" fontWeight={600} color="gray.700">{`${i.name}: ${i.value}`}</Text>
                            </Flex>
                        ))}
                    </Flex>
                </Box>
            </Grid>
            <SimpleGrid columns={{ base: 1, lg: 2 }} gap={6} mb={6}>
                <Box bg="white" borderRadius="xl" p={5} boxShadow="0 1px 3px rgba(0,0,0,0.08)" textAlign="center">
                    <Text fontSize="lg" fontWeight={700} color="gray.800" mb={4}>Students by Disability Type</Text>
                    <Box mx="auto" width="100%" h="320px">
                        <ResponsiveContainer width="100%" height="100%">
                            <PieChart>
                                <Pie
                                    data={countByDisabilityType.filter(entry => entry.value !== 0)}
                                    labelLine={false}
                                    label={renderCustomizedLabel}
                                    outerRadius="80%"
                                    fill="#8884d8"
                                    dataKey="value"
                                >
                                    {countByDisabilityType.map((entry, index) => (
                                        <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                    ))}
                                </Pie>
                            </PieChart>
                        </ResponsiveContainer>
                    </Box>
                    <Flex flexWrap="wrap" justify="center" gap={3} mt={2}>
                        {countByDisabilityType.map((i, index) => (
                            <Flex key={i.name} alignItems="center" gap={2}>
                                <Box bg={COLORS[index % COLORS.length]} w="12px" h="12px" borderRadius="sm" />
                                <Text fontSize="sm" fontWeight={600} color="gray.700">{`${i.name}: ${i.value}`}</Text>
                            </Flex>
                        ))}
                    </Flex>
                </Box>
                <Box bg="white" borderRadius="xl" p={5} boxShadow="0 1px 3px rgba(0,0,0,0.08)" textAlign="center">
                    <Text fontSize="lg" fontWeight={700} color="gray.800" mb={4}>Students by Disability ID Type</Text>
                    <Box mx="auto" width="100%" h="320px">
                        <ResponsiveContainer width="100%" height="100%">
                            <PieChart>
                                <Pie
                                    data={countByDisabilityId.filter(entry => entry.value !== 0)}
                                    labelLine={false}
                                    label={renderCustomizedLabel}
                                    outerRadius="80%"
                                    fill="#8884d8"
                                    dataKey="value"
                                >
                                    {countByDisabilityId.map((entry, index) => (
                                        <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                    ))}
                                </Pie>
                            </PieChart>
                        </ResponsiveContainer>
                    </Box>
                    <Flex flexWrap="wrap" justify="center" gap={3} mt={2}>
                        {countByDisabilityId.map((i, index) => (
                            <Flex key={i.name} alignItems="center" gap={2}>
                                <Box bg={COLORS[index % COLORS.length]} w="12px" h="12px" borderRadius="sm" />
                                <Text fontSize="sm" fontWeight={600} color="gray.700">{`${i.name}: ${i.value}`}</Text>
                            </Flex>
                        ))}
                    </Flex>
                </Box>
            </SimpleGrid>
            <SimpleGrid columns={{ base: 1, lg: 2 }} gap={6} mb={6}>
                <Box bg="white" borderRadius="xl" p={5} boxShadow="0 1px 3px rgba(0,0,0,0.08)" textAlign="center">
                    <Text fontSize="lg" fontWeight={700} color="gray.800" mb={4}>Teachers by Gender</Text>
                    <Box mx="auto" width="100%" h="320px">
                        <ResponsiveContainer width="100%" height="100%">
                            <PieChart>
                                <Pie
                                    data={pieChartDataTeacherByGender.filter(entry => entry.value !== 0)}
                                    labelLine={false}
                                    label={renderCustomizedLabel}
                                    outerRadius="80%"
                                    fill="#8884d8"
                                    dataKey="value"
                                >
                                    {pieChartDataTeacherByGender.map((entry, index) => (
                                        <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                    ))}
                                </Pie>
                            </PieChart>
                        </ResponsiveContainer>
                    </Box>
                    <Flex flexWrap="wrap" justify="center" gap={3} mt={2}>
                        {pieChartDataTeacherByGender.map((i, index) => (
                            <Flex key={i.name} alignItems="center" gap={2}>
                                <Box bg={COLORS[index % COLORS.length]} w="12px" h="12px" borderRadius="sm" />
                                <Text fontSize="sm" fontWeight={600} color="gray.700">{`${i.name}: ${i.value}`}</Text>
                            </Flex>
                        ))}
                    </Flex>
                </Box>
                <Box bg="white" borderRadius="xl" p={5} boxShadow="0 1px 3px rgba(0,0,0,0.08)" textAlign="center">
                    <Text fontSize="lg" fontWeight={700} color="gray.800" mb={4}>Therapists by Gender</Text>
                    <Box mx="auto" width="100%" h="320px">
                        <ResponsiveContainer width="100%" height="100%">
                            <PieChart>
                                <Pie
                                    data={pieChartDataTherapistByGender.filter(entry => entry.value !== 0)}
                                    labelLine={false}
                                    label={renderCustomizedLabel}
                                    outerRadius="80%"
                                    fill="#8884d8"
                                    dataKey="value"
                                >
                                    {pieChartDataTherapistByGender.map((entry, index) => (
                                        <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                    ))}
                                </Pie>
                            </PieChart>
                        </ResponsiveContainer>
                    </Box>
                    <Flex flexWrap="wrap" justify="center" gap={3} mt={2}>
                        {pieChartDataTherapistByGender.map((i, index) => (
                            <Flex key={i.name} alignItems="center" gap={2}>
                                <Box bg={COLORS[index % COLORS.length]} w="12px" h="12px" borderRadius="sm" />
                                <Text fontSize="sm" fontWeight={600} color="gray.700">{`${i.name}: ${i.value}`}</Text>
                            </Flex>
                        ))}
                    </Flex>
                </Box>
            </SimpleGrid>

            <Box bg="white" borderRadius="xl" p={5} boxShadow="0 1px 3px rgba(0,0,0,0.08)" maxW={{ lg: '100%' }} overflowX="auto">
                <Text fontSize="lg" fontWeight={700} color="gray.800" mb={4}>Student Review Scores by Year</Text>
                <StudentScore />
            </Box>
        </Box>
    );
}
